<div [ngClass]="{ open: isOpen }" class="tour">
  <div [ngClass]="realStyle" class="opener">
    <div class="openerBorder"></div>
    <div [ngClass]="realStyle" class="tourInfo">
      <div class="miniTitle">{{ title }}</div>
      <div (click)="close()" class="close icon-HamburgerAppClose" id="HeadTourCloseButton"></div>
      <div [innerHTML]="contents" class="contents"></div>
      <div class="buttons">
        @if (tourLink !== '') {
          <div (click)="goto()" class="linkButton">Learn More</div>
        }
        <div class="bubbles">
          @for (item of tourItems; track item; let index = $index) {
            <div
              [ngClass]="{ on: index === itemIndex }"
              class="bubble"
            ></div>
          }
        </div>
        @if (itemIndex !== tourItems.length - 1) {
          <button (click)="next()" class="button" id="TourNextButton">
            Next
          </button>
        }
        @if (itemIndex === tourItems.length - 1) {
          <button
            (click)="close()"
            class="button"
            id="TourCloseButton"
            >
            Close
          </button>
        }
      </div>
    </div>
  </div>
</div>
